import React, { FC } from 'react';
import { Text, View } from 'react-native';
import { ColorFunction } from '@styles/colors/types';
import { ProductionBatchStatistics } from '@interfaces/search';
import { ScaleFunction } from '@components/operatorPanel/interfaces';
import { scale as initialScale } from '@components/frame';
import { font as initialFont } from '@styles/fonts';
import i18n from 'i18n-js';
import { useReadyPcsV2Values } from '@components/common/ReadyPcsV2/hooks/useReadyPcsV2Values';

export interface ReadyPcsQuantityProps {
  batch: ProductionBatchStatistics | null;
  showOnlyTarget?: boolean;
  C: ColorFunction;
  quantityProduced?: number;
  quantityTarget?: number;
  fontForQuantityProduced?: keyof typeof initialFont;
  fontForQuantityTarget?: keyof typeof initialFont;
  colorForQuantityProduced?: string;
  colorForQuantityTarget?: string;
  spaceBeforePcs?: boolean;
  scale?: ScaleFunction;
  font?: typeof initialFont;
}

export const ReadyPcsQuantity: FC<ReadyPcsQuantityProps> = ({
  batch,
  C,
  showOnlyTarget,
  quantityProduced,
  quantityTarget,
  spaceBeforePcs,
  scale = initialScale,
  font = initialFont,
  fontForQuantityProduced = 'Time 2',
  fontForQuantityTarget = 'Time 4',
  colorForQuantityProduced = 'Label/Light/Tertiary',
  colorForQuantityTarget = 'Label/Light/Tertiary',
}) => {
  const { targetQuantity, producedQuantity, shouldDisplayRightPart } = useReadyPcsV2Values({
    batch,
    showOnlyTarget,
    quantityProduced,
    quantityTarget,
  });

  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'baseline',
      }}
    >
      <Text style={[font[fontForQuantityProduced], { color: C(colorForQuantityProduced) }]}>{producedQuantity}</Text>
      {shouldDisplayRightPart && (
        <Text style={[font['Footnote'], { color: C('Label/Light/Tertiary'), transform: [{ translateY: scale(-1) }] }]}>{'\u00A0/\u00A0'}</Text>
      )}
      {shouldDisplayRightPart && <Text style={[font[fontForQuantityTarget], { color: C(colorForQuantityTarget) }]}>{targetQuantity}</Text>}
      {spaceBeforePcs && <Text>{'\u00A0'}</Text>}
      {producedQuantity != null && <Text style={[font['Caption 2'], { color: C('Label/Light/Tertiary') }]}> {i18n.t('Pcs')}</Text>}
    </View>
  );
};

export default ReadyPcsQuantity;
